import React, { Component } from "react";
import { View, StyleSheet, Text, TouchableOpacity } from "react-native";
import { Data, PosData } from "../~Utilities/Data";
import {ScrollView,  } from 'react-native-gesture-handler';
import { Connection, ConnectionMkt, ConnectionOrd } from "../~Utilities/Connection";
import OBNakedText from "../C_Text/OBNakedText";
import OBChange from "../C_Text/OBChange";
import OB from './OB';
import Utilities from '../~Utilities/Utilities';
import OBNakedStaticStyleText from "../C_Text/OBNakedStaticStyleText";
import { Feather  } from '@expo/vector-icons';
import { PriceType } from "../~Utilities/Rq";
import { FontAwesome  } from '@expo/vector-icons';
import { FontInfo } from "../~Utilities/Constants";
import Text3 from "../C_Text/Text3";
import Text2Eqv from "../C_Text/Text2Eqv";

/*   ====================================================================   */

export interface IORDInfo
{
  oData     : Data;
  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void
}

/*   ====================================================================   */

interface IORDState 
  {
  visible             : boolean,
  pos_data?           : PosData,
  count_total         : number;
  count_working       : number;
  height              : number;
  }

/*   ====================================================================   */

export default class ORD extends Component<IORDInfo>
 {
  state : IORDState = {visible:false, pos_data:undefined, count_total:0, count_working:0, height:0};

  /*   -------------------------------------------------------------------   */

  public bookRef  : ScrollView | any = null;
  //public pos_data : PosData | undefined;

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  /*   -------------------------------------------------------------------   */

  this.Hide          = this.Hide.bind(this);
  this.Show          = this.Show.bind(this);
  this.SelectAccount = this.SelectAccount.bind(this);
  this.GetData       = this.GetData.bind(this);
  this.UpdateData    = this.UpdateData.bind(this);
  this.GetOrdColor   = this.GetOrdColor.bind(this);

  let oPosData       = this.GetData(this.props.oData.sv_account);

  this.state         = {
                        visible:true, 
                        pos_data: oPosData,
                        count_total: oPosData? 
                                     oPosData.orders.length : 0,
                        count_working: oPosData? 
                                       oPosData.orders_working.length: 0,
                        height:OB.WHITE_HEIGHT,
                        };


}

  /*   -------------------------------------------------------------------   */

  Hide()
  {
  this.setState({visible:false})
  }

  /*   -------------------------------------------------------------------   */

  Show()
  {
  if (this.state.visible == false)
    this.setState({visible:true})
  }

  /*   -------------------------------------------------------------------   */

  UpdateFont()
  {
  if (this.state.height != OB.WHITE_HEIGHT)
    this.setState({height:OB.WHITE_HEIGHT});
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  this.props.bindEvent(this.UpdateData, true);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.props.bindEvent(this.UpdateData, false);
  }

  /*   ------------------------------------------------------------------   */

  componentDidUpdate()
  {
  }

  /*   -------------------------------------------------------------------   */

  GetData(sAccKey : string = "")
  {
    if (Connection.oAccStore.size > 0)
      {
      let acckey : string;

      if (sAccKey && Connection.oAccStore.has(sAccKey))
        acckey = sAccKey;
      else
        acckey = Connection.oAccStore.keys().next().value;
  
      // let acckey = sAccKey;
      
      // if (!acckey)
      //   acckey = Connection.oAccStore.keys().next().value;

      let token   = "";

      if (this.props.oData.trading_symbol && this.props.oData.trading_exchange)
        token = this.props.oData.trading_symbol + "." + this.props.oData.trading_exchange;
      else
        token = this.props.oData.token;

      let key = acckey + token;

      //alert(key);
       
       let data1 = Connection.oPosStore.get(key);

       if (data1 == undefined)
        {
        //Utilities.Sendlog("New Pos: " + acckey + " token: " + token);

        data1 = new PosData(acckey, token);
        Connection.oPosStore.set(key, data1);
        }

       //alert(key + data1?.net_qty);

       return(data1);
      }
    // else
    //   Utilities.Sendlog("account size is 0");
  }

  /*   -------------------------------------------------------------------   */

  SelectAccount(oData : PosData)
  {
  this.setState({pos_data: oData, }); 

  //this.pos_data = oData;  

  if (__DEV__)
    Utilities.Sendlog("ORD Setting account: " + this.state.pos_data?.token + " " + this.state.pos_data?.acc_key);
  //this.forceUpdate();

  // this.setState({count_total: oData.orders.length,
  //                count_working: oData.orders_working.length}); 
  // this.forceUpdate();                 
  }

  /*   -------------------------------------------------------------------   */

  UpdateData()
  {
  if (Connection.oAccStore.size > 0 && 
      this.state.pos_data         == undefined)
      {
      let oData = this.GetData(this.props.oData.sv_account);

      if (oData != null)
        this.SelectAccount(oData);
      }

  if (this.state.pos_data != undefined)
    {
    if (this.state.pos_data.orders_working.length != this.state.count_working ||
        this.state.pos_data.orders.length         != this.state.count_total)
      {
      this.setState({count_total: this.state.pos_data.orders.length,
                     count_working: this.state.pos_data.orders_working.length}); 
      }
    }
  }

  /*   ------------------------------------------------------------------   */

  GetOrdColor()
  {
  if (this.state.pos_data                       == undefined ||
      this.state.pos_data.orders_working        == undefined ||
      this.state.pos_data.orders_working.length == 0)
    return('gainsboro');
  else if (this.state.pos_data.order_buy_qty && !this.state.pos_data?.order_sell_qty)
     return('dodgerblue');
  else if (!this.state.pos_data.order_buy_qty && this.state.pos_data?.order_sell_qty)
    return('hotpink');
  else
    return('#9f00ff');
  }

  /*   ---------------------------------------------------------------------   */

  render() {
    if (this.state.visible == false)
      return(null);
    else  
    return (
      <View style={[styles.container, {height:this.state.height,}]}>

       <View style={{alignSelf:'center', paddingRight:ConnectionMkt.DEVICE_NAME == ConnectionMkt.DEVICE_WEB? 15 : 0, marginBottom:2, alignItems:'center', flexDirection:'column'}}>
        <Text style={[FontInfo.appStyles.txt_normal, {textAlign:'center', 
                      marginHorizontal:15, alignSelf:'center', color:'gray', marginBottom:2}]} >{this.props.oData.symbol_name} </Text>
        <View style={{alignSelf:'center', flexDirection:'row'}}>
        
        <Feather name="arrow-down" size={14} color="gray"/>
        <OBNakedStaticStyleText
                    bindEvent={this.props.bindEvent} 
                    style={[FontInfo.appStyles.txt_normal, {marginLeft:-5, color: 'gray',}]} 
                    getText={()=>{return(!this.props.oData.low? "" : ConnectionMkt.getFmt(this.props.oData.low, this.props.oData))}}
                    />

        <OBNakedText
                    bindEvent={this.props.bindEvent} 
                    getStyle={()=>{return(this.props.oData.pc >= 0? 
                            [FontInfo.appStyles.txt_bold, {color:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red])}} 
                    getText={()=>{return(ConnectionMkt.getFmt(this.props.oData.last, this.props.oData))}}
                    />

        <OBNakedStaticStyleText
                    bindEvent={this.props.bindEvent} 
                    style={[FontInfo.appStyles.txt_normal, {marginRight:-5, color: 'gray',}]} 
                    getText={()=>{return(!this.props.oData.high? "" : ConnectionMkt.getFmt(this.props.oData.high, this.props.oData))}}
                    />                    
        <Feather name="arrow-up" size={14} color="gray" />
        </View>

        <OBChange 
                    bindEvent={this.props.bindEvent} 
                    getStyle={()=>{return(this.props.oData.pc >= 0? 
                            [FontInfo.appStyles.txt_bold, styles.title_small_green_bg, {backgroundColor:FontInfo.sGreen}] : [FontInfo.appStyles.txt_bold, styles.title_small_red_bg])}} 
                    style={[FontInfo.appStyles.txt_bold, styles.title_small_text]}
                    getText={()=>{return(this.props.oData.nc < 0? ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData) : "+" + ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData))}}
                    />


       </View>


       {/* <OBNakedStaticStyleText 
                    bindEvent={this.props.bindEvent} 
                    style={styles.row_vol} 
                    getText={()=>{return(this.state.count.toString())}}
                    /> */}

      {/* <View style={{flexDirection:'row', alignSelf:'center'}}>
      <TouchableOpacity style={{backgroundColor:'#f5f6fa', margin:10, padding:8, borderRadius:10, minWidth:90}}><Text style={{alignSelf:'center', fontWeight:'bold', color:'olive', }}>Cancel All</Text></TouchableOpacity>
      <TouchableOpacity style={{backgroundColor:'#f5f6fa', margin:10, padding:8, borderRadius:10, minWidth:90}}><Text style={{alignSelf:'center', fontWeight:'bold', color:'red',}}>Flatten</Text></TouchableOpacity>
      </View> */}

      <ScrollView nestedScrollEnabled contentContainerStyle={{backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}>

      <View style={{flexDirection:'row', width:200, margin:10, padding:8, alignItems:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, fontSize:FontInfo.iFontSize + 2, minWidth:120, marginLeft:10, textAlign:'center', backgroundColor:'transparent' }]}>Working Orders</Text>


      {/* <View style={this.state.count_working == 0? {backgroundColor:'grey', marginLeft:10, borderRadius:5} : {backgroundColor:this.GetOrdColor(), marginLeft:10, borderRadius:5}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4, textAlign:'center'}]}>{this.state.pos_data?.net_qty == undefined? "0" : this.state.count_working}</Text>
      </View> */}

      <OBChange bindEvent={this.props.bindEvent}
                getStyle={()=>{return(this.state.count_working == 0? {backgroundColor:'grey', marginLeft:10, borderRadius:5} : {backgroundColor:this.GetOrdColor(), marginLeft:10, borderRadius:5} ) } } 
                style={ [FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4, textAlign:'center'}] }
                getText={ ()=>{ return( this.state.pos_data?.net_qty == undefined? "0" : this.state.pos_data?.orders_working.length + ""  )  }  }
                />

      </View>

      <View>
      {
        this.state.pos_data?.orders_working.map((basket_id) => 
          {
          let oOrdData = Connection.oOrdStore.get(basket_id);

          if (oOrdData == undefined)
            return(null);

          const getStatus = () => {return(oOrdData? oOrdData.status : "")};

          const getOrder  = () => {if (oOrdData == undefined) return("empty");
                                   else
                                   {
                                  //  let sPrice = "";
                                   
                                  //  if (oOrdData.price_type_api == PriceType.STOP_LIMIT ||
                                  //      oOrdData.price_type_api == PriceType.STOP_MARKET)
                                  //      sPrice = ConnectionMkt.getFmtWithPad(oOrdData.trigger_price, this.props.oData, " @");
                                  //  else if (oOrdData.price_type_api == PriceType.LIMIT)
                                  //      sPrice = ConnectionMkt.getFmtWithPad(oOrdData.limit_price, this.props.oData, " @");

                                       
                                   return(oOrdData.txn_type + " " + 
                                          oOrdData.qty + " " + 
                                          oOrdData.price_type + 
                                          getPrice()); 
                                  };
                                 };

          const getPrice = () => {if (oOrdData == undefined) return("empty");
                                   else
                                   {
                                   let sPrice = "";
                                   
                                   if (oOrdData.price_type_api == PriceType.STOP_LIMIT ||
                                       oOrdData.price_type_api == PriceType.STOP_MARKET)
                                       sPrice = ConnectionMkt.getFmtWithPad(oOrdData.trigger_price, this.props.oData, " @");
                                   else if (oOrdData.price_type_api == PriceType.LIMIT)
                                       sPrice = ConnectionMkt.getFmtWithPad(oOrdData.limit_price, this.props.oData, " @");

                                   return(sPrice);
                                  };
                                 };

          const cancelOrder = () => {if (oOrdData == undefined) return;
                                   else
                                   {
                                   ConnectionOrd.oConn?.Rq_CancelOrder(oOrdData.acc_key, 
                                                                       oOrdData.basket_id,
                                                                       "Recent Orders, Cancel Button",);  
                                   }
                                   };                                 

                                          //!oOrdData.limit_price? "" : "@" + ConnectionMkt.getFmt(oOrdData.limit_price? oOrdData.limit_price : 0, this.props.oData) ); };
          
          return(
                <View key={basket_id} style={{width:Utilities.WIDTH - 50, margin:10, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
                  <Text style={[FontInfo.appStyles.txt_bold, {color:'slategrey', alignSelf:'center'}]}>{oOrdData.basket_id}</Text>

                  <TouchableOpacity style={{alignItems:'center', justifyContent:'center', borderBottomLeftRadius:10, borderTopLeftRadius:10, position:'absolute', backgroundColor:FontInfo.sDivider, top:0, left:0, bottom:0, width:30}} 
                    onPress={()=>{cancelOrder()}}>
                  {/* <AntDesign name="closecircle" size={30} color="#ef3038" /> */}
                   <FontAwesome style={{marginLeft:2}} name="close" size={20} color="#ff355e" />
                  </TouchableOpacity>

                  <View style={oOrdData.txn_type == "Buy"? {borderRadius:5, backgroundColor:'dodgerblue'} : {borderRadius:5, backgroundColor:'hotpink'}}>
                    <OBNakedStaticStyleText
                      style={[FontInfo.appStyles.txt_bold, {color:'white', marginHorizontal:4}]} 
                      getText={getOrder}
                      bindEvent={this.props.bindEvent}
                    />
                  {/* <Text style={{color:'white', fontSize:12, marginHorizontal:4, fontWeight:'bold'}}>{oOrdData.txn_type} {oOrdData.qty} {oOrdData.price_type} {oOrdData.limit_price? "@" + ConnectionMkt.getFmt(oOrdData.limit_price, this.props.oData) : ""}</Text> */}
                  </View>

                  <OBNakedStaticStyleText 
                    style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sGreen}]} 
                    getText={getStatus}
                    bindEvent={this.props.bindEvent}
                   />

                </View>
                );
          })
      }
      </View>

      <View style={{flexDirection:'row', width:200, margin:10, padding:8, alignItems:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, fontSize:FontInfo.iFontSize + 2, minWidth:120, marginLeft:10, textAlign:'center', backgroundColor:'transparent' }]}>Completed</Text>

      {/* <View style={{backgroundColor:'grey', marginLeft:10, borderRadius:5}}>
      <Text style={[FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4}]}>{this.state.pos_data?.net_qty == undefined? "0" : this.state.count_total - this.state.count_working}</Text>
      </View> */}

      <OBChange bindEvent={this.props.bindEvent}
                getStyle={()=>{return( {backgroundColor:'grey', marginLeft:10, borderRadius:5} ) } } 
                style={ [FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4}] }
                getText={ ()=>{ return( this.state.pos_data?.net_qty == undefined? "0" : this.state.pos_data?.orders.length - this.state.pos_data?.orders_working.length + ""  )  }  }
                />

      </View>

      {/* <View style={{width:200, margin:10, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:'#f5f6fa', borderRadius:10}}>
      <Text style={{fontWeight:'bold', color:'black'}}>Completed Orders {this.state.count_total - this.state.count_working}</Text>
      </View> */}

      <View>
        {
        this.state.pos_data?.orders.map((basket_id) => 
          {
          const getPrice = () => {if (oOrdData == undefined) return("empty");
                                   else
                                   {
                                   let sPrice = "";
                                   
                                   if (oOrdData.price_type_api == PriceType.STOP_LIMIT ||
                                       oOrdData.price_type_api == PriceType.STOP_MARKET)
                                       sPrice = ConnectionMkt.getFmtWithPad(oOrdData.trigger_price, this.props.oData, " @");
                                   else if (oOrdData.price_type_api == PriceType.LIMIT)
                                       sPrice = ConnectionMkt.getFmtWithPad(oOrdData.limit_price, this.props.oData, " @");

                                   return(sPrice);
                                  };
                                 };                                 

          let oOrdData = Connection.oOrdStore.get(basket_id);

          if (oOrdData == undefined || oOrdData.status != "complete")
            return(null);

          return(
                <View key={basket_id} style={{width:Utilities.WIDTH - 50, margin:10, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
                {/* <View style={{backgroundColor:'#f5f6fa', borderTopEndRadius:10, borderTopStartRadius:10, }}>
                <Text style={{fontSize:12, color:'black', marginTop:4, alignSelf:'center', fontWeight:'bold'}}>{oOrdData.basket_id}</Text>
                </View> */}

                {/* <View style={{padding:8, alignItems:'center', justifyContent:'center', borderBottomLeftRadius:10, borderBottomRightRadius:10, backgroundColor:'#f5f6fa'}}> */}

                  <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey', alignSelf:'center'}]}>{oOrdData.basket_id}</Text>

                  <View style={oOrdData.completion_reason=="filled"? (oOrdData.txn_type == "Buy"? {borderRadius:5, backgroundColor:'dodgerblue'} : {borderRadius:5, backgroundColor:'hotpink'}) : {borderRadius:5, backgroundColor:'grey'}}>
                  <Text style={[FontInfo.appStyles.txt_normal, {color:'white', marginHorizontal:4, }]}>{oOrdData.txn_type} {oOrdData.qty} {oOrdData.price_type} {getPrice()}</Text>
                  </View>

                  {/* <View style={{flexDirection:'row'}}> */}
                  <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey'}]}>{oOrdData.completion_reason} {oOrdData.fill_price? "@" + ConnectionMkt.getFmt(oOrdData.fill_price, this.props.oData) : ""}</Text>

                  <Text style={oOrdData.remarks? [FontInfo.appStyles.txt_normal, {maxWidth: Utilities.WIDTH - 60, textAlign:'center', color:'slategrey', flexWrap:'wrap'}] : {display:'none'}}>{oOrdData.remarks}</Text>
                  {/* </View> */}

                {/* </View> */}
                </View>
                );
          })
        }
      </View>
      </ScrollView>

      </View>
    );
  }
}

/*   ---------------------------------------------------------------------   */

const styles = StyleSheet.create({
  container: {
    marginTop: 4,
    backgroundColor: 'transparent',
  },

  listItem: {
    flex: 1,
    backgroundColor: 'transparent',
    justifyContent: 'center',
    paddingLeft: 0,
  },

  title_small_green: {
    color: 'green',
  },  

  title_small_red: {
    color: 'red',
  },

  title_small_green_bg: {
    backgroundColor: 'green',

    borderRadius: 4,  
    paddingRight:2,
  },  

  title_small_red_bg: {
    backgroundColor: 'red',

    borderRadius: 4,
    paddingRight:2,
  },

  title_small_text: {
    marginLeft:4,
    color: 'white',
    backgroundColor: 'transparent',
  },  
  
});

